const alphaNumericSplit = /([0-9]+)/gm;

export const alphaNumeric = (a: string, b: string) => {
  const splitA = a.split(alphaNumericSplit).filter(Boolean);
  const splitB = b.split(alphaNumericSplit).filter(Boolean);

  while (splitA.length && splitB.length) {
    // Just ignore the undefined, and let Javascript deal with it
    const aa = splitA.shift()!;
    const bb = splitB.shift()!;

    const an = Number.parseInt(aa, 10);
    const bn = Number.parseInt(bb, 10);

    const combo = [an, bn].sort();

    // Both are string
    if (Number.isNaN(combo[0])) {
      if (aa > bb) {
        return 1;
      }
      if (bb > aa) {
        return -1;
      }
      continue;
    }

    // One is a string, one is a number
    if (Number.isNaN(combo[1])) {
      return Number.isNaN(an) ? -1 : 1;
    }

    // Both are numbers
    if (an > bn) {
      return 1;
    }
    if (bn > an) {
      return -1;
    }
  }

  return a.length - b.length;
};
